import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const Content = () => {
  const stats = [
    { label: 'Published', value: '156', change: '+12', changeType: 'positive' },
    { label: 'In Progress', value: '23', change: '+5', changeType: 'positive' },
    { label: 'Scheduled', value: '42', change: '+8', changeType: 'positive' },
    { label: 'Engagement', value: '8.4K', change: '+23%', changeType: 'positive' },
  ];

  const content = [
    { title: 'AI Transformation Guide', type: 'Blog Post', status: 'Published', date: 'Dec 28' },
    { title: 'Product Demo Video', type: 'Video', status: 'In Progress', date: 'Dec 30' },
    { title: 'Weekly Newsletter', type: 'Email', status: 'Scheduled', date: 'Jan 2' },
    { title: 'Case Study: TechCorp', type: 'PDF', status: 'Draft', date: 'Jan 5' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">Content Management</h1>
        <p className="lm-page-subtitle">Create and manage marketing content</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">Recent Content</h3>
          <Button variant="primary" size="sm" icon="plus">Create New</Button>
        </div>
        <div className="lm-grid">
          {content.map((item, index) => (
            <div key={index} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{item.title}</span>
                <span className="lm-grid-card-badge" style={{
                  background: item.status === 'Published' ? 'var(--success-soft)' :
                             item.status === 'Scheduled' ? 'var(--primary-soft)' : 'var(--warning-soft)',
                  color: item.status === 'Published' ? 'var(--success)' :
                         item.status === 'Scheduled' ? 'var(--primary)' : 'var(--warning)'
                }}>{item.status}</span>
              </div>
              <div className="lm-grid-card-content">
                <p>{item.type} • {item.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Content;
